import { render } from "./EdgEvaluator.vue?vue&type=template&id=2b39a5b5&scoped=true"
import script from "./EdgEvaluator.vue?vue&type=script&lang=js"
export * from "./EdgEvaluator.vue?vue&type=script&lang=js"

import "./EdgEvaluator.vue?vue&type=style&index=0&id=2b39a5b5&lang=scss&scoped=true"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b39a5b5"]])

export default __exports__